import React, { useContext, useEffect, useReducer, useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import LoadingBox from "../components/LoadingBox";
import { default as config } from "../config.json";
import useAxios from "../hooks/useAxios";
import "../ProductSeed.css";
import { Store } from "../Store";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loading: true };
    case "CREATE_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "CREATE_FAIL":
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default function ProductSeed() {
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [filterTag, setFilterTag] = useState("#");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);

  const [allTags, setAllTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [samplesAlreadyInUse, setSamplesAlreadyInUse] = useState([]);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [productPrices, setProductPrices] = useState({});

  const axios = useAxios();

  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const { state } = useContext(Store);
  const { products: storeProducts } = state;

  useEffect(() => {
    async function fetchProducts() {
      try {
        const { data } = await axios.get("/api/productsamples");
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    }
    fetchProducts();
  }, []);

  useEffect(() => {
    if (filterTag && filterTag !== "#") {
      setFilteredTags(allTags.filter((t) => t.includes(filterTag)));
    } else {
      setFilteredTags([...allTags]);
    }
  }, [filterTag, allTags]);

  useEffect(() => {
    setSamplesAlreadyInUse(storeProducts.map((s) => s.sample));
  }, [storeProducts]);

  useEffect(() => {
    let tags = [];
    products.forEach((product) => {
      if (product.tags) {
        product.tags.forEach((t) => {
          if (!tags.includes(t)) {
            tags.push(t);
          }
        });
      }
    });

    setAllTags(tags);
  }, [products]);

  const handleProductClick = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) {
        return prevSelected.filter((id) => id !== productId);
      } else {
        return [...prevSelected, productId];
      }
    });
  };

  const handleFilterChange = (e) => {
    let value = e.target.value;

    // Check if the first character is not '#'
    if (value.charAt(0) !== "#") {
      value = `#${value}`; // Add '#' to the beginning
    }

    setFilterTag(value); // Update the state with the modified value
  };

  const handleTagClick = (tag) => {
    setSelectedTags((prevSelected) => {
      if (prevSelected.includes(tag)) {
        return prevSelected.filter((t) => t !== tag);
      } else {
        return [...prevSelected, tag];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedProducts.length > 0) {
      setSelectedProducts([]);
    } else {
      const allProductIds = filteredProducts
        .filter((p) => !samplesAlreadyInUse.includes(p._id))
        .map((product) => product._id);
      setSelectedProducts(allProductIds);
    }
  };

  const handleAktar = () => {
    setShowPriceModal(true);
  };

  const handlePriceChange = (productId, price) => {
    setProductPrices((prevPrices) => ({
      ...prevPrices,
      [productId]: price,
    }));
  };

  const handleConfirmPrices = async () => {
    try {
      dispatch({ type: "CREATE_REQUEST" });
      await axios.post("/api/products/migrate", {
        products: products
          .filter((p) => selectedProducts.includes(p._id))
          .map((p) => ({
            ...p,
            price: productPrices[p._id] || p.price,
          })),
      });
      toast.success(
        `${selectedProducts.length} ürün başarılı bir şekilde sisteme aktarıldı!`
      );
      dispatch({ type: "CREATE_SUCCESS" });
      setSelectedProducts([]);
      setShowPriceModal(false);
    } catch (error) {
      dispatch({
        type: "CREATE_FAIL",
        error,
      });
      toast.error("Hata, ürünler aktarılamadı!", error);
    }
  };

  useEffect(() => {
    const newFilteredProducts = products
      .filter((p) => p.status)
      .filter((product) =>
        product.tags
          ? selectedTags.length > 0
            ? selectedTags.some((tag) => product.tags.includes(tag))
            : true
          : false
      );
    setFilteredProducts(newFilteredProducts);
  }, [products, selectedTags]);

  return (
    <div className="product-grid-container">
      {loading ? (
        <LoadingBox>Ürünler Yükleniyor</LoadingBox>
      ) : (
        <>
          <div className="filter-container">
            <label htmlFor="user" className="form-label">
              Etiket Ara&nbsp;
            </label>

            <input
              type="text"
              value={filterTag}
              onChange={handleFilterChange}
            />
            <div className="suggested-tags">
              {filteredTags.map((tag, index) => (
                <div
                  key={index}
                  className={`suggested-tag ${
                    selectedTags.includes(tag) ? "selected-tag" : ""
                  }`}
                  onClick={() => handleTagClick(tag)}
                >
                  {tag}
                </div>
              ))}
            </div>
            <div className="mt-3">
              <InputGroup>
                {filteredProducts.length > 0 && (
                  <button
                    onClick={handleSelectAll}
                    className={
                      selectedProducts.length > 0
                        ? "btn btn-danger"
                        : "btn btn-success"
                    }
                  >
                    {selectedProducts.length > 0 ? (
                      <FaTimes style={{ marginRight: "8px" }} />
                    ) : (
                      <FaCheck style={{ marginRight: "8px" }} />
                    )}
                    {selectedProducts.length > 0
                      ? `${selectedProducts.length} ürünü iptal et`
                      : `${
                          filteredProducts.filter(
                            (p) => !samplesAlreadyInUse.includes(p._id)
                          ).length
                        } ürünü seç`}
                  </button>
                )}

                {selectedProducts.length > 0 && !loading && (
                  <button onClick={handleAktar} className="btn btn-primary">
                    {`${selectedProducts.length} ürünü `} Aktar &nbsp;
                    <i className="fas fa-arrow-right" />
                  </button>
                )}
                {loading && (
                  <LoadingBox inline={true}>
                    <>&nbsp;Aktarılıyor</>
                  </LoadingBox>
                )}
              </InputGroup>
            </div>
          </div>
          <div className="product-grid">
            {filteredProducts.map((product) => (
              <div
                key={product._id}
                className={`product-item ${
                  selectedProducts.includes(product._id) ? "selected" : ""
                } ${samplesAlreadyInUse.includes(product._id) ? "faded" : ""}`}
                onClick={() =>
                  !samplesAlreadyInUse.includes(product._id) &&
                  handleProductClick(product._id)
                }
              >
                <img
                  src={product.image || config.default_image}
                  alt={product.name}
                  className="product-image"
                />
                <div className="product-name">{product.name}</div>
                <div className="product-description">{product.description}</div>
              </div>
            ))}
          </div>
        </>
      )}
      <Modal show={showPriceModal} onHide={() => setShowPriceModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Ürün Fiyatlarını Güncelle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProducts.map((productId) => {
            const product = products.find((p) => p._id === productId);
            return (
              <Form.Group key={productId} className="mb-3">
                <Form.Label>{product.name}</Form.Label>
                <Form.Control
                  type="number"
                  value={productPrices[productId] || product.price || ""}
                  onChange={(e) => handlePriceChange(productId, e.target.value)}
                />
              </Form.Group>
            );
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPriceModal(false)}>
            Vazgeç
          </Button>
          <Button variant="primary" onClick={handleConfirmPrices}>
            Fiyatları Onayla ve Aktar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
